<div style="background: #fff; border: solid #ccc 1px; padding: 3px; border-radius: 3px;">
    <div>

        <select (ngModelChange)="onChange($event)" [ngModel]="selectedState" class="form-select form-select-sm">
            <option>All</option>
            <option *ngFor="let state of allStates" [hidden]="checkHidden(state)">
                {{state === appStatesTexts.readytoPublish ? appStatesTexts.readytoPublishText :
                state === appStatesTexts.readytoActivate ? appStatesTexts.readytoActivateText : state}}
            </option>
            <!-- <option>Requested</option>
            <option>Processing</option>
            <option>Ready To Publish</option>
            <option>Available</option>
            <option>Revoked</option> -->
        </select>
    </div>
</div>